import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms'
import { MatCheckboxModule } from '@angular/material/checkbox';

import { DocumentComponent } from './document.component';

@NgModule({
    declarations: [ DocumentComponent ],
    imports: [
        MatCheckboxModule,
        FormsModule
    ],
    exports: [ DocumentComponent, MatCheckboxModule, FormsModule ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DocumentModule {}